<ng-template #modalExcel let-c="close" let-d="dismiss">
  <div class="modal-content">
    <div class="modal-header pb-0">
      <h2 class="mb-0">Exportar Excel</h2>
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click'); updatePreferenceDataBase();">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body p-3" style="overflow-x:hidden;">

      <div class="row">
        <div class="col-12 d-flex justify-content-center mt-1">
          <button type="button" class="btn btn-info" ngbTooltip="Exporta la tabla seleccionada." placement="bottom"
                  (click)="this.excel.exportarExcel(this.tableNative);">
            <i class="bi bi-file-spreadsheet-fill"></i> Exportar Vista Actual
          </button>
        </div>
      </div>

      <form [formGroup]="form" (ngSubmit)="exportarColumnas()">
        <hr>
        <h2>Reporte Personalizado</h2>
        <p>Total Registros: <b>{{this.lengthData}}</b></p>
        <div class="d-flex justify-content-start">
          <button class="btn btn-success mb-1" type="submit"><i class="bi bi-palette-fill mr-1"></i> Generar Reporte
          </button>
          <button class="btn btn-info mb-1" type="button" (click)="selectAll();" style="margin-left: 5px;" ngbTooltip="Seleccionar todo"><i
            class="bi bi-check-square"></i>
          </button>
        </div>


        <div formArrayName="columnaSeleccionada">
          <div *ngFor="let column of this.displayedColumnsAux; let i = index">
            <div class="custom-switch custom-switch-info custom-control-inline mb-1"
                 *ngIf="this.formatColumn[i]!==this.constants.CONTROL">
              <input type="checkbox" [id]="i" [formControlName]="i" class="custom-control-input">
              <label for="{{i}}" class="custom-control-label mr-1">
                <span>{{ this.dataNames[i] }}</span></label>
            </div>
          </div>
        </div>


      </form>


    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-info btn" (click)="d('Cross click'); updatePreferenceDataBase();"><i
      class="ft-x"></i>Cerrar
    </button>
  </div>
</ng-template>
